














// eslint-disable-next-line no-unused-vars
import { DropdownItem, MultiSelectItem } from '@/main/store/@types/dropdown.d';

import { BaseInput } from '#components/dms/common/baseInput';
import DmsWrapper from '#components/dms/form/Wrapper.vue';

// eslint-disable-next-line no-unused-vars
import { EditableStatus } from '../../constants';

export default BaseInput.extend({
	name: 'DmsMultiSelect',
	components: { DmsWrapper },
	props: {
		selectList: { type: Array as () => DropdownItem[], required: true },
		value: { type: Array as () => MultiSelectItem[] },
		filterable: Boolean,
		required: Boolean,
		span: { type: Number, default: 24 },
		noLabelAlign: { type: Boolean, default: false },
	},
	data() {
		return {
			isDropdownOpen: false,
			multiple: true,
		};
	},
	computed: {
		selectPlaceholderText(): string | undefined {
			return this.placeholderText ? `-- ${this.placeholderText} --` : undefined;
		},
		selectValue(): number[] {
			const filter = (valueItem: MultiSelectItem) => this.selectList.some(
				(item) => item.Value === valueItem.Value && valueItem.UpdateStatus !== EditableStatus.DELETED,
			);
			return this.value.filter(filter).map((item) => item.Value);
		},
		selectListFiltered(): any[] {
			return this.selectList.filter((item) => this.selectValue.some((sItem) => item.Value === sItem));
		},
		clearableCmp(): boolean {
			return !this.isDropdownOpen && this.clearable;
		},
	},
	methods: {
		optionLabel(item: { Label: string; Text: string }) {
			return item.Label ? `${item.Text} (${item.Label})` : item.Text;
		},
		updateValue(value: number[]) {
			const toDelete = this.value.filter((item) => !value.some((id) => id === item.Value) && item.UpdateStatus !== EditableStatus.INSERTED);
			toDelete.forEach((item) => {
				item.UpdateStatus = EditableStatus.DELETED;
			});

			const isUnModified = (id: number) => this.value.some((item) => id === item.Value && item.UpdateStatus !== EditableStatus.INSERTED);

			const inserted = value.map((id) => ({
				Value: id,
				UpdateStatus: isUnModified(id) ? EditableStatus.UNMODIFIED : EditableStatus.INSERTED,
			}));

			this.$emit('update:value', [...inserted, ...toDelete]);
		},
		visibleChange(value: boolean) {
			this.isDropdownOpen = value;
		},
	},
});
